import postReport from 'views/Questions/api/postReport';
import showNotification from 'utils/showNotification';

const sendReportHandler = async (
  type: 'questions' | 'answers',
  data: string | number,
) => {
  const res = await postReport(type, data);
  if (res?.success) {
    showNotification(
      'success',
      `Cпасибо, мы проверим этот ${type === 'questions' ? 'вопрос' : 'ответ'}`,
    );
  } else if (res?.error) {
    showNotification('error', 'Извини, произошла ошибка, попробуй позже');
  } else {
    showNotification('error', 'Извини, ты же оповестил нас');
  }
};

export default sendReportHandler;
